import {
  notify,
  mediaToBase64,
  fetchMediaData,
  dateFormatting,
  manageErrorLogs,
  mediaURLtoBlob,
} from "./commonFunction";
import {
  DB,
  insertEntryInDB,
  updateEntryInDB,
  getEntryByFieldFromDB,
  getMultipleEntriesFromDB,
  clearTablesWithTran,
} from "./db";
import moment from "moment";
import { apiEndpoints } from "./constants";
import {
  reqToFetchDataProcess,
  reqToInitialSyncProcess,
  reqToResetApiMessage,
  reqToStartSyncProcess,
  reqToUploadMediaFile,
  reqToGetAddressFromLatLong,
  reqToGetTakedDetailsList,
  reqToAddTakedDetails,
} from "../store/slice/offlineSlice";
import { insertTakedDetailsInDB } from "./OfflineAPIDBQuery";

// FETCH LATEST DATA
export const getLatestDataFromDB = async (type, dispatch, user) => {
  try {
    if (
      type === "login" ||
      type === "sync" ||
      type === "isNMonth" ||
      type === "finalUpload"
    ) {
      dispatch(reqToFetchDataProcess(true));
      dispatch(reqToResetApiMessage(""));
    }
    if (type === "sync" || type === "isNMonth" || type === "autoRefresh") {
      await getLatestTakedDetailsFromDB(dispatch);
      dispatch(reqToResetApiMessage(""));
    } else if (type === "login" || type === "finalUpload") {
      const fetchData = await getMultipleEntriesFromDB([
        "userData",
        "activeCycle",
        "takedDetails",
      ]);
      if (!fetchData || Object.keys(fetchData)?.length === 0) {
        throw new Error(`No data found in DB!`);
      }
      const { userData, activeCycle, takedDetails } = fetchData;
      const oldUser =
        Array.isArray(user) && user?.length > 0 ? user[0] : user || null;
      const newUser = userData && userData?.length > 0 ? userData[0] : "";
      const checkUser =
        oldUser && newUser
          ? newUser?.user_id !== oldUser?.user_id ||
            newUser?.username !== oldUser?.username
          : true;
      const cycleData =
        Array.isArray(activeCycle) && activeCycle?.length > 0
          ? activeCycle[0]
          : "";
      const isCurrCycle =
        cycleData && cycleData?.start
          ? moment(cycleData?.start).isSame(dateFormatting(), "month")
          : false;
      if (checkUser || !isCurrCycle || takedDetails?.length === 0) {
        await getLatestTakedDetailsFromDB(dispatch);
        dispatch(reqToResetApiMessage(""));
      }
    }
    dispatch(reqToFetchDataProcess(false));
    dispatch(reqToInitialSyncProcess(false));
  } catch (error) {
    manageErrorLogs(error);
    dispatch(reqToFetchDataProcess(false));
    dispatch(reqToInitialSyncProcess(false));
    throw error;
  }
};
export const getLatestTakedDetailsFromDB = async (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(
      reqToGetTakedDetailsList({
        data: "",
        onSuccess: async (res) => {
          if (res?.status !== 200) return resolve(res);
          let newData = [];
          if (Array.isArray(res?.data)) {
            newData = res?.data.map((item, i) => {
              if (Array.isArray(item?.images) && item?.images?.length > 0) {
                item?.images?.forEach((img) => {
                  updateMediaFileInDB(img?.image_url, "attachment");
                });
              }
              return { ...item, id: i + 1 };
            });
          }
          await insertTakedDetailsInDB(newData);
          resolve(res);
        },
        onFailure: (err) => {
          reject(err);
        },
        dispatch,
      })
    );
  }).catch((error) => {
    manageErrorLogs(error);
    notify("Failed to fetch master md!");
  });
};
// SUBMIT DATA
export const handleOfflineDataSyncing = async (
  dispatch,
  sync,
  syncType = "sync"
) => {
  sync && dispatch(reqToStartSyncProcess(true));
  dispatch(reqToResetApiMessage(""));
  return new Promise(async (resolve, reject) => {
    try {
      const fetchData = await getMultipleEntriesFromDB([
        "addedTakeDetails",
        "userData",
      ]);
      if (!fetchData || Object.keys(fetchData)?.length === 0) {
        throw new Error(`No data found in DB!`);
      }
      const { addedTakeDetails, userData } = fetchData;
      if (addedTakeDetails?.length > 0) {
        await submitIndexedDbData(
          dispatch,
          addedTakeDetails,
          userData,
          sync,
          syncType
        )
          .then(async (res) => {
            dispatch(reqToStartSyncProcess(false));
            dispatch(reqToInitialSyncProcess(false));
            await clearTablesWithTran("errorLogs");
            resolve(res);
          })
          .catch((error) => {
            manageErrorLogs(error);
            dispatch(reqToStartSyncProcess(false));
            dispatch(reqToInitialSyncProcess(false));
            reject(error);
          });
      } else {
        if (
          sync &&
          (syncType === "sync" ||
            syncType === "isNMonth" ||
            syncType === "finalUpload")
        ) {
          getLatestDataFromDB(syncType, dispatch, userData);
        } else if (syncType === "autoRefresh") {
          getLatestDataFromDB(syncType, dispatch, userData);
        }
        dispatch(reqToStartSyncProcess(false));
        dispatch(reqToInitialSyncProcess(false));
        await clearTablesWithTran("errorLogs");
        resolve();
      }
    } catch (error) {
      manageErrorLogs(error);
      dispatch(reqToStartSyncProcess(false));
      dispatch(reqToInitialSyncProcess(false));
      reject(error);
    }
  });
};
export const submitIndexedDbData = async (
  dispatch,
  addedTakeDetails,
  userData,
  sync,
  syncType
) => {
  return new Promise(async (resolve, reject) => {
    const promises = [];
    const isSync = syncType === "sync" || syncType === "autoRefresh";
    if ((sync || (!sync && isSync)) && addedTakeDetails?.length > 0) {
      promises.push(
        submitTakedDetailsWhenOnline(
          dispatch,
          addedTakeDetails,
          "addedTakeDetails"
        )
      );
    }
    await Promise.allSettled(promises)
      .then(async (results) => {
        const isRejected = results.find((item) => item.status === "rejected");
        if (isRejected && isRejected?.reason) {
          reject(isRejected.reason);
        } else {
          results.forEach(async (result) => {
            if (sync && !isRejected && syncType === "sync") {
              if (["addedTakeDetails"].includes(result?.value)) {
                await getLatestTakedDetailsFromDB(dispatch);
              }
            }
          });
          resolve(results);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const submitTakedDetailsWhenOnline = async (
  dispatch,
  addedTakeDetails,
  type
) => {
  const promises = [];
  for (const item of addedTakeDetails) {
    try {
      const result = await new Promise(async (resolve, reject) => {
        let location = "";
        if (Array.isArray(item?.images) && item?.images?.length > 0) {
          await uploadImagesForTakeDetails(item, dispatch);
        }
        await DB.takedDetails.update(item?.id, item);
        await DB.addedTakeDetails.update(item?.id, item);
        if (item?.latitude && item?.longitude) {
          location = await reqToGetLocation(item, dispatch);
          item.address = location.address;
          item.latitude = location.latitude;
          item.longitude = location.longitude;
        }
        const imageArray = item?.images?.map((img) => img?.image_url);
        dispatch(
          reqToAddTakedDetails({
            data: {
              activity: item?.activity,
              address: item?.address,
              branch: item?.branch,
              latitude: item?.latitude,
              longitude: item?.longitude,
              personnel: item?.personnel,
              restaurant: item?.restaurant,
              image: imageArray,
              recode_time: item?.recode_time || new Date(),
            },
            onSuccess: async (res) => {
              await DB.addedTakeDetails.delete(item?.id);
              resolve(res);
            },
            onFailure: async (error) => {
              if (
                error &&
                error?.response &&
                error?.response?.status === 400 &&
                error?.response?.data?.toLowerCase() === "already exist"
              ) {
                await DB.addedTakeDetails.delete(item?.id);
                resolve();
              } else {
                await insertEntryInDB("errorLogs", {
                  data: item,
                  api: apiEndpoints.addTakeDetails,
                  error: JSON.stringify(error),
                  date: new Date(),
                  response: JSON.stringify({
                    data: error?.response?.data,
                    status: error?.response?.status,
                    statusText: error?.response?.statusText,
                  }),
                });
                reject(error);
              }
            },
          })
        );
      });
      promises.push({ data: result, status: true });
    } catch (error) {
      promises.push({ data: error, status: false });
    }
  }
  const failedCalls = promises.filter((result) => !result.status);
  if (failedCalls?.length === 0) {
    return Promise.resolve(type);
  } else {
    return Promise.reject(failedCalls[0].data);
  }
};
const uploadImagesForTakeDetails = async (item, dispatch) => {
  for (let i = 0; i < item.images.length; i++) {
    const imageData = item.images[i];
    const blobData = imageData.base64?.includes("base64")
      ? await mediaURLtoBlob(imageData.base64)
      : imageData.image_url || imageData.base64;
    const imageName = await processMediaFile(blobData, dispatch);
    item.images[i] = { image_url: imageName, base64: imageName };
  }
};

export const processMediaFile = (url, dispatch, fileName) => {
  return new Promise((resolve, reject) => {
    if (url && url?.size) {
      const formData = new FormData();
      if (fileName) {
        formData.append("file", url, fileName);
      } else {
        const fileURL = url?.type?.split("/")[1];
        const fileURL2 = ["svg", "webp"].includes(fileURL) ? "png" : fileURL;
        formData.append("file", url, `attachment.${fileURL2 || "png"}`);
      }
      dispatch(
        reqToUploadMediaFile({
          data: formData,
          onSuccess: async (res) => {
            if (res && res?.data?.length > 0) {
              if (url?.name && url?.name.includes(".xls")) {
                let excelUrl = res?.data[0]?.videoUrl.split("/");
                let excelName = excelUrl && excelUrl[excelUrl?.length - 1];
                resolve(excelName);
              } else {
                let imagesUrl = res?.data[0]?.imageUrlBigUrl.split("/");
                let imageName = imagesUrl && imagesUrl[imagesUrl?.length - 1];
                await updateMediaFileInDB(imageName, "sign", url);
                resolve(imageName);
              }
            }
          },
          onFailure: async (error) => {
            const base64 = await mediaToBase64(url);
            await insertEntryInDB("errorLogs", {
              data: base64 ? "file is available" : "",
              api: apiEndpoints.media,
              error: JSON.stringify(error),
              date: new Date(),
              response: JSON.stringify({
                data: error?.response?.data,
                status: error?.response?.status,
                statusText: error?.response?.statusText,
              }),
            });
            reject(error);
          },
        })
      );
    } else {
      resolve(url);
    }
  });
};
export const reqToGetLocation = async (newData, dispatch) => {
  return new Promise((resolve, reject) => {
    const reqObj = {
      latitude: newData.latitude,
      longitude: newData.longitude,
    };
    dispatch(
      reqToGetAddressFromLatLong({
        data: reqObj,
        onSuccess: (response) => {
          const location = {
            address: response.data,
            latitude: newData.latitude,
            longitude: newData.longitude,
          };
          resolve(location);
        },
        onFailure: async (error) => {
          const location = {
            address: "",
            latitude: newData?.latitude || "",
            longitude: newData?.longitude || "",
          };
          resolve(location);
          await insertEntryInDB("errorLogs", {
            data: reqObj,
            api: apiEndpoints.getLocation,
            error: JSON.stringify(error),
            date: new Date(),
            response: JSON.stringify({
              data: error?.response?.data,
              status: error?.response?.status,
              statusText: error?.response?.statusText,
            }),
          });
        },
      })
    );
  });
};

export const updateMediaFileInDB = async (file, type, blobData) => {
  if (!file || Object.keys(file)?.length === 0) return;
  try {
    const tableName =
      type === "pdf" || type === "image" ? "productImages" : "mediaFiles";
    const findFile = await getEntryByFieldFromDB(tableName, "file", file);
    if (findFile?.length === 0 || !findFile[0]?.base64) {
      const blob = blobData ? blobData : await fetchMediaData(file);
      const base64 = blob ? await mediaToBase64(blob) : "";
      await updateEntryInDB(tableName, "file", file, {
        file: file,
        type: type,
        blob: "",
        base64: base64,
      });
      return blob;
    }
  } catch (error) {
    manageErrorLogs(error);
    return file;
  }
};
export const getMediaFileFromDB = async (dataList, file, base64, fetch) => {
  try {
    if (
      dataList &&
      dataList[file] &&
      !dataList[base64] &&
      !dataList[file]?.size &&
      !dataList[file]?.includes("base64")
    ) {
      const fileData = await getEntryByFieldFromDB(
        "mediaFiles",
        "file",
        dataList[file]
      );
      if (fetch === "blob") {
        const blob = fileData?.[0]?.base64
          ? await mediaURLtoBlob(fileData?.[0]?.base64)
          : "";
        return blob;
      } else {
        return fileData?.[0]?.base64 ? fileData?.[0]?.base64 : "";
      }
    } else if (dataList[base64] && dataList[base64]?.includes("base64")) {
      return dataList[base64];
    } else {
      return "";
    }
  } catch (error) {
    manageErrorLogs(error);
    return "";
  }
};
